// extracted by mini-css-extract-plugin
export default {"quote":"models-page-footer_quote__rvkOT","counter":"models-page-footer_counter__LoOHE","counterBig":"models-page-footer_counterBig__o+3od"};